var TabDeadlineModule = /** @class */ (function () {
    function TabDeadlineModule() {
    }
    return TabDeadlineModule;
}());
export { TabDeadlineModule };
